export default __webpack_public_path__ + "static/media/Hood of the Faceless Chaos.0851f694.jpg";